import { render, staticRenderFns } from "./InventarioSimBase.vue?vue&type=template&id=759356b1&"
import script from "./InventarioSimBase.vue?vue&type=script&lang=ts&"
export * from "./InventarioSimBase.vue?vue&type=script&lang=ts&"
import style0 from "./InventarioSimBase.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports